const PAID = 'paid';
const ON_HOLD = 'onhold';
const PROCESSED = 'processed';
const PACKING = 'packing';

export const orderStatuses = [PAID, ON_HOLD, PROCESSED, PACKING] as const;
